export default "__VITE_ASSET__dcabbede__$_?react__"